import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// canvas point under the pointer, aware of object-fit: contain letterboxing
export const cvPoint = (c, e) => {
  const r = c.getBoundingClientRect(), k = Math.min(r.width / c.width, r.height / c.height);
  const ox = r.left + (r.width - c.width * k) / 2, oy = r.top + (r.height - c.height * k) / 2;
  return [Math.min(c.width, Math.max(0, (e.clientX - ox) / k)), Math.min(c.height, Math.max(0, (e.clientY - oy) / k))];
};
export const cvScale = (c) => { const r = c.getBoundingClientRect(); return Math.min(r.width / c.width, r.height / c.height) || 1; };

const S = 130, ZOOM = 3;
// magnifier above the finger: 3x of the displayed canvas, crosshair on the exact point
export default function Loupe({ src, p, at }) {
  const ref = useRef(null);
  useEffect(() => {
    const id = requestAnimationFrame(() => {
      const c = ref.current, s = src.current; if (!c || !s) return;
      const g = c.getContext('2d'), half = S / 2 / (cvScale(s) * ZOOM);
      g.fillStyle = '#0f172a'; g.fillRect(0, 0, S, S);
      g.drawImage(s, p[0] - half, p[1] - half, half * 2, half * 2, 0, 0, S, S);
      g.strokeStyle = '#fff'; g.lineWidth = 3; g.beginPath(); g.moveTo(S / 2, 8); g.lineTo(S / 2, S / 2 - 8); g.moveTo(S / 2, S / 2 + 8); g.lineTo(S / 2, S - 8); g.moveTo(8, S / 2); g.lineTo(S / 2 - 8, S / 2); g.moveTo(S / 2 + 8, S / 2); g.lineTo(S - 8, S / 2); g.stroke();
      g.strokeStyle = '#dc2626'; g.lineWidth = 1.5; g.stroke();
    });
    return () => cancelAnimationFrame(id);
  });
  const top = at[1] - S - 40 < 8 ? at[1] + 40 : at[1] - S - 40, left = Math.max(8, Math.min(window.innerWidth - S - 8, at[0] - S / 2));
  return createPortal(<canvas ref={ref} width={S} height={S} className="loupe" data-testid="loupe" style={{ top, left }} />, document.body);
}
